'use client';

import { Alert, Stack } from '@mui/material';
import { differenceInSeconds, formatDistance } from 'date-fns';
import { useEffect, useMemo, useState } from 'react';
import ActiveBasketsList from '../../components/ActiveBasketsList';
import FreeTrialBanner from '../../components/FreeTrialBanner';
import HomePageBanner from '../../components/HomePageBanner';
import IntradayRecommendations from '../../components/IntradayRecommendations';
import StatCardGroup from '../../components/StatCardGroup';
import { useBothUserPlans } from '../../store/subscribe/usePlans';
import { useBrokerConfig } from '../../store/useBrokerConfig';
import { useMixedPanel } from '../../store/useMixPanel';
const Root = () => {
  const { trackPageView } = useMixedPanel();
  useEffect(() => {
    trackPageView('/');
  }, [trackPageView]);

  const [showGetStarted, setShowGetStarted] = useState(false);
  const { long } = useBothUserPlans();
  const { data: brokerConfig } = useBrokerConfig();
  const subscriptionExpiring = useMemo(() => {
    return differenceInSeconds(long?.expireTime ?? new Date(), new Date());
  }, [long]);

  const subscriptionDueDays =
    brokerConfig?.broker_config?.subscription_due_days;
  return (
    <Stack gap={2}>
      {subscriptionDueDays &&
        subscriptionExpiring > 0 &&
        subscriptionExpiring <= subscriptionDueDays * 3600 * 24 && (
          <Alert severity="warning" sx={{ py: 3, px: 2 }}>
            {`Your subscription will expire ${formatDistance(
              long?.expireTime ?? new Date(),
              new Date(),
              { addSuffix: true }
            )}`}
          </Alert>
        )}
      <ActiveBasketsList setShowGetStarted={setShowGetStarted} />
      <FreeTrialBanner />
      <HomePageBanner />
      <IntradayRecommendations />
      <StatCardGroup />
    </Stack>
  );
};

export default Root;
